import React from 'react';

import { CentroDistribuicaoFormComp, CentroDistribuicaoListComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function CentroDistribuicaoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CENTRO_DISTRIBUICAO_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <CentroDistribuicaoListComp />
        </ListagemProvider>
    );
}

export function CentroDistribuicaoForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CENTRO_DISTRIBUICAO_GERENCIAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <CentroDistribuicaoFormComp />
        </FormProvider>
    );
}
